import React from 'react'
import CreditRequestSvg from './CreditRequestSvg'
import AdminToolsSvg from './AdminToolsSvg'
import RedChartSvg from './RedChartSvg'
import GreenChartSvg from './GreenChartSvg'
import ExportAll from './ExportAll'
import DataBaseSvg from './DataBaseSvg'
import TableExportSvg from './TableExportSvg'
import AdminTeamSvg from './AdminTeamSvg'


const Icons = {
    CreditRequestSvg,
    AdminToolsSvg,
    RedChartSvg,
    GreenChartSvg,
    ExportAll,
    DataBaseSvg,
    TableExportSvg,
    AdminTeamSvg
}

export default Icons